<template>
  <DemoTemplate title="Button" description="A growing collection of 54 button components built with Next.js and TailwindCSS.">
    <div class="group/item relative text-center" v-for="cmp in componentList">
      <component :is="cmp" />
    </div>
  </DemoTemplate>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import DemoTemplate from "../templates/DemoTemplate.vue";

const componentList = [
  defineAsyncComponent(() => import("../atoms/button/Button-01.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-02.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-03.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-04.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-05.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-06.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-07.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-08.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-09.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-10.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-11.vue")),
  defineAsyncComponent(() => import("../atoms/button/Button-12.vue")),
];
</script>
